
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/content/[seriesId]",
      function () {
        return require("private-next-pages/content/[seriesId]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/content/[seriesId]"])
      });
    }
  